import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button, FormControl, FormControlLabel, Switch
} from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';
import { applyFilters, resetApplyFilters, updateFilters } from '../../../actions/usersWithoutComputersFilters';
import { fetchUsersWithoutComputers } from '../../../actions';
import { LOCATION_STATES, LOCATION_STATES_ID, mapUWCFiltersStateToQuery } from '../../../utils';
import LocationTreeModeTypeahead from '../Typeahead/LocationTreeModeTypeahead';
import GeneralProgressBar from '../GeneralProgressBar';

const styles = theme => ({
    button: {
        margin: theme.spacing(0.5),
        marginTop: theme.spacing(2),
        flexGrow: 1
    },
    filterForm: {
        padding: theme.spacing(1)
    },
    controlButtons: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around'
    },
    marginStates: {
        marginBottom: '5px'
    }
});

class UsersWithoutComputersFilters extends Component {
    handleResetClick = async () => {
        await this.props.resetApplyFilters();

        const filters = mapUWCFiltersStateToQuery(this.props.UWCFilters);

        this.props.fetchUsersWithoutComputers(filters);
    };

    handleClickApply = e => {
        e.preventDefault();
        const filters = mapUWCFiltersStateToQuery(this.props.UWCFilters);
        this.props.applyFilters(this.props.UWCFilters);
        this.props.fetchUsersWithoutComputers(filters);
    };

    handleChangeMultiSuggestion = suggestion => {
        this.props.updateFilters({
            ...this.props.UWCFilters,
            officeIds: suggestion
        });
    };

    handleChangeStatusOffices = name => e => {
        this.props.updateFilters({
            ...this.props.UWCFilters,
            [name]: e.target.checked ? LOCATION_STATES.all : LOCATION_STATES.onlyActive
        });
    };

    render() {
        const { classes, UWCFilters, offices, t } = this.props;
        const { officeState } = UWCFilters;

        const isOfficeState = officeState === LOCATION_STATES_ID.all.id;

        return offices ? (
            <form
                className={classNames('filter', classes.filterForm)}
                autoComplete="off"
                onSubmit={this.handleClickApply}
            >
                <FormControl
                    fullWidth
                    margin="dense"
                >
                    <FormControlLabel
                        className={classes.marginStates}
                        control={(
                            <Switch
                                checked={isOfficeState}
                                onChange={this.handleChangeStatusOffices('officeState')}
                            />
                        )}
                        label={t('active/All')}
                    />
                    <LocationTreeModeTypeahead
                        data={[isOfficeState ? offices.all : offices.onlyActive]}
                        placeholder="office"
                        locationId={UWCFilters.officeIds.map(office => office.value)}
                        setLocation={value =>
                            this.handleChangeMultiSuggestion((value.map(item => ({ value: item }))))}
                        multi
                        descendants
                    />
                </FormControl>

                <div className={classes.controlButtons}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleResetClick}
                    >
                        {t('reset')}
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        type="submit"
                    >
                        {t('apply')}
                    </Button>
                </div>
            </form>
        ) : (<GeneralProgressBar />);
    }
}

UsersWithoutComputersFilters.propTypes = {
    UWCFilters: PropTypes.shape({
        officeIds: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number,
            }),
        ),
        officeState: PropTypes.number,
        itemsPerPage: PropTypes.number,
        pageNumber: PropTypes.number,
        sortBy: PropTypes.string,
        sortOrder: PropTypes.string
    }),
    offices: PropTypes.object,
    classes: PropTypes.shape({
        filterForm: PropTypes.string,
        controlButtons: PropTypes.string,
        button: PropTypes.string,
    }),
    fetchUsersWithoutComputers: PropTypes.func,
    updateFilters: PropTypes.func,
    applyFilters: PropTypes.func,
    resetApplyFilters: PropTypes.func,
};

const mapStateToProps = ({ usersWithoutComputersFilters, infrastructure }) => ({
    UWCFilters: usersWithoutComputersFilters.currentFilters,
    offices: infrastructure.locations[0]
});

export default compose(
    withTranslation('global'),
    connect(mapStateToProps, {
        fetchUsersWithoutComputers,
        updateFilters,
        applyFilters,
        resetApplyFilters
    }),
    withStyles(styles)
)(UsersWithoutComputersFilters);
